<template>
 
      <div class="flex flex-column pl-2 pr-2">
        <div class="mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row">
          <h2 class="">FARBY</h2>
          <router-link to="/mod-stock/colors/0" >
            <PrimevueButton label="Pridať farbu" severity="success" icon="pi pi-plus" text raised class="uppercase"/>
          </router-link>
        </div>
        <DataTable 
          scrollable :scrollHeight="`${this.vh - 290}px`"
          :value="this.colors"
          stripedRows
          row-hover
          v-model:selection="this.selectedColor"
          selectionMode="single"
          :metaKeySelection="false"
          @rowSelect="editColor(this.selectedColor.id)"
          tableStyle="width: 100%"
          :virtualScrollerOptions="{ itemSize: 40 }"
        >
        <Column header="" style="min-width: 5%">
          <template #body="slotProps">
            <div
              class="color-box"
              :style="{ backgroundColor: slotProps.data.colorHash }"
            ></div>
          </template>
        </Column>

          <Column field="code" header="Kód" style="min-width: 10%">
          </Column>

          <Column field="description" header="Popis" style="min-width: 30%">
          </Column>

          <Column field="shade" header="Odtieň" style="min-width: 10%">
          </Column>

          <Column header="Imitácia dreva" >
            <template #body="slotProps">
              <div v-if="slotProps.data.imitation">áno</div>
            </template>
          </Column>

          <Column header="" >
            <template #body="slotProps">
              <PrimevueButton type="button" v-tooltip.top="{ value: 'Editácia farby' }" icon="pi pi-pencil" @click="editColor(slotProps.data.id)" text size="small"/>
            </template>
          </Column>

          <Column header="" >
            <template #body="slotProps">
                <PrimevueButton type="button" icon="pi pi-trash" @click="deleteColor(slotProps.data.id)" text severity="danger" size="small"/>
            </template>
          </Column>

        </DataTable>
      </div>

      <ConfirmDialog></ConfirmDialog>
</template>

<script lang="ts">
import Security from "@/components/security";
import {store} from "@/components/store";
import router from "@/router";
import notie from "notie/dist/notie";
import PrimevueButton from 'primevue/button';
import Column from "primevue/column";

export default {
  name: "ColorList",
  components: {
    PrimevueButton,
    Column,
  },
  data() {
    return {
      store,
      colors: [],
      vh: 0,
      dialogClosedByAccept: false,
    }
  },
  beforeMount() {
    
    if (Security.requireToken()){
      store.selectModul = this.$route.path.split("/")[1]
      this.setDynamicHeight(); 
      // Aktualizácia výšky pri zmene veľkosti okna
      window.addEventListener("resize", this.setDynamicHeight);

      fetch(this.store.Api_url + "/v1/color?query=deleted:0", Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              //this.$emit('error', responseData.data);
              notie.alert({
                type: 'error',
                text: "Zoznam farieb sa nepodarilo načítať"
              })
            } else {
              
              this.colors = responseData.data
            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri načítaní farieb" + error);
          })
    }
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.setDynamicHeight);
  },

  methods: {
    editColor(id:number) {
      router.push('/mod-stock/colors/' + String(id))
    },
    
    setDynamicHeight() {
      this.vh = window.innerHeight; // Nastavenie viditeľnej výšky
    },

    deleteColor(id:number){
      //if(confirm("Naozaj chcete ODSTRÁNIŤ kategóriu?")){
        Security.requireToken();
        this.dialogClosedByAccept = false;
        this.$confirm.require({
          message: 'Naozaj chcete ODSTRÁNIŤ farbu?',
          header: 'Odstránenie farby',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: "Áno",
          rejectLabel: "Nie",

          accept: () => {
            //this.user.admin = event.target.checked;
            this.dialogClosedByAccept = true;

            fetch(store.Api_url + "/v1/color/"+String(id)+"?query=deleted:0" , Security.requestOptions("DELETE"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                //console.log("error:", responseData.message);
                //this.$emit('error', responseData.message);
                notie.alert({
                  type: 'error',
                  text: "Nepodarilo sa odstrániť farbu"
                })
              } else {

                this.colors = responseData.data;
                notie.alert({
                  type: 'success',
                  text: "Farba bola odstránená",
                  position: "bottom"
                })
              }
            })
            .catch((error) => {
              //alert('chyba pri nacitani objednavok: ' + error)
              notie.alert({
                  type: 'error',
                  text: "Nastala chyba pri odstránení farby: "+error
                })             
            })
          },
          //reject: () => {
          //  this.user.admin = false;
          //},
          onHide: () => {
              //if(!this.dialogClosedByAccept){
              //  this.user.admin = false;
              //}
              this.dialogClosedByAccept = false;
          }

        });
        

 
      //}
    },
  }  
  
}
</script>



<style scoped>

</style>